export default "__VITE_ASSET__C1V6WhmU__"